<div [ngClass]="{'has-photo': basketItem?.basketPhoto }" class="basket-content grid-container locus-basket-item">
  <div class="basket-inner">
    <div class="basket-row">
      <div class="basket-column">
        <div class="basket-label">{{'iaa.app.locus.locusBasket.locusBasketItem.basketType' | translate}}</div>
        {{ (basketItem?.basketType?.wordName || '') | translateLang | async }} 
      </div>
      <div class="basket-column">
        <div class="basket-label">{{'iaa.app.locus.locusBasket.locusBasketItem.secondaryType' | translate}}</div>
        <div class="basket-value">   {{ basketItem?.basketSubType }} </div>
      </div>
      <div class="basket-column">
        <div class="basket-label">{{'iaa.general.period' | translate}}</div>
        <div class="basket-value">{{ (basketItem?.basketPeriod?.wordName|| '') | translateLang | async }}</div>
      </div>
    </div>

    <div class="basket-row">
      <div class="basket-column">
        <div class="basket-label">{{'iaa.general.date' | translate}}</div>
        <div class="basket-value">{{ basketItem?.basketDate | date: "yy.MM.dd" }}</div>
      </div>
      <div class="basket-column">
        <div class="basket-label">{{'iaa.app.locus.locusBasket.locusBasketItem.openingHeight' | translate}}</div>
        <div class="basket-value">{{ basketItem?.basketOpeneddHeigth | number : '1.0-2' }}</div>
      </div>
      <div class="basket-column">
        <div class="basket-label">{{'iaa.app.locus.locusBasket.locusBasketItem.closingHeight' | translate}} </div>
        <div class="basket-value">{{ basketItem?.basketClosedHeigth | number : '1.0-2' }}</div>
      </div>
    </div>
  </div>

  <div class="image">
    <img *ngIf="basketItem?.basketPhoto" [src]="basketItem?.basketPhoto?.imageUrl" class="basket-image" alt="Basket Img"/>
    <div *ngIf="!basketItem?.basketPhoto" class="basket-image-placeholder"></div>
  </div>

  <div class="basket-row description">
    <div class="basket-column-full">
      <div class="basket-label">{{'iaa.general.description' | translate}}</div>
      <div class="basket-value">{{ basketItem?.basketDescription }}</div>
    </div>
  </div>
</div>